import {
  PRE_FILL_SUBMISSION_FORM,
  SAVE_SUBMISSION_FORM_PRO,
  SET_SUBMISSION_ID,
  SET_SORT_BY,
} from './constants';

export const initialState = {
  formId: -1,
  proStatus: '',
  formData: {
    title: '',
    type: 'real_wedding',
  },
  sortBy: [
    {
      id: 'submitted',
      desc: true,
    },
  ],
};

function formReducer(state = initialState, action) {
  switch (action.type) {
    case PRE_FILL_SUBMISSION_FORM:
      return {
        ...state,
        formData: action.payload,
      };

    case SAVE_SUBMISSION_FORM_PRO:
      return {
        ...state,
        formData: action.payload,
      };

    case SET_SUBMISSION_ID:
      return {
        ...state,
        formId: action.payload,
      };

    case SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };

    default:
      return state;
  }
}

export default formReducer;
